import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
  RouteRecordRaw,
} from "vue-router";
import HomeView from "../views/Home.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  //列表
  {
    path: "/list",
    redirect: "/list/news/001001",
    name: "List",
    children: [
      {
        path: ":listType/:nodeNum",
        name: "listList",
        component: () => import("@/views/List.vue"),
      },
    ],
  },
  //单页
  {
    path: "/infoShow",
    redirect: "/infoShow/001001",
    name: "InfoShow",
    children: [
      {
        path: ":nodeNum",
        name: "InfoshowList",
        component: () => import("@/views/InfoShow.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory("/servicehall/"),
  routes,
});

export default router;
